import axios from 'axios';

const findAgendamentos = (params) => axios.get('/calendario/agendamentos', { params });
const findCancelamentos = (params) => axios.get('/calendario/cancelamentos', { params });

export default {
  findAgendamentos,
  findCancelamentos,
};
